var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountLogo = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EFF9",
    d: "M0 14.4c0-6 0-9 1.528-11.102a8 8 0 0 1 1.77-1.77C5.4 0 8.4 0 14.4 0h3.2c6 0 9 0 11.102 1.528a8 8 0 0 1 1.77 1.77C32 5.4 32 8.4 32 14.4v3.2c0 6 0 9-1.528 11.102a8 8 0 0 1-1.77 1.77C26.6 32 23.6 32 17.6 32h-3.2c-6 0-9 0-11.102-1.528a8 8 0 0 1-1.77-1.77C0 26.6 0 23.6 0 17.6z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "account-logo_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#065EC5",
    d: "M10.667 16.667h2V18h-2zM14 18h2v-1.333h-2zm-3.333 2.667h2v-1.334h-2zm3.333 0h2v-1.334h-2zm-3.333-8h2v-1.334h-2zm3.333 0h2v-1.334h-2zm-3.333 2.666h2V14h-2zm3.333 0h2V14h-2zm10-2V24H8V10a2 2 0 0 1 2-2h6.667a2 2 0 0 1 2 2v1.333H22a2 2 0 0 1 2 2M17.333 10a.667.667 0 0 0-.666-.667H10a.667.667 0 0 0-.667.667v12.667h8zm5.334 3.333a.667.667 0 0 0-.667-.666h-3.333v10h4zM20 18h1.333v-1.333H20zm0 2.667h1.333v-1.334H20zm0-5.334h1.333V14H20z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "account-logo_svg__a"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h16v16H8z"
  })))));
};
export { SvgAccountLogo as ReactComponent };
export default __webpack_public_path__ + "eebf1d3d32313aca4afb2d79b3e22c1f.svg";